var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Observer } from "mobx-react-lite";
import React from "react";
import { ContextColor } from "../../constants/color.enum";
import joinClassName from "../../utils/className.utils";
import { useProps } from "../../utils/mobx.utils";
import './BaseHeading.scss';
var BaseHeading = function (props) {
    var children = props.children, rest = __rest(props, ["children"]);
    var p = useProps(rest);
    return React.createElement(Observer, { children: function () {
            var HeadingTag = p.level ? "h" + p.level : 'strong';
            return (React.createElement(HeadingTag, __assign({ className: joinClassName('BaseHeading', p.className), children: p.heading || props.children }, p.color && {
                'data-primary-color': p.color === ContextColor.Primary ? '' : p.color
            })));
        } });
};
export default BaseHeading;
